// extracted by mini-css-extract-plugin
export var component = "MainImageCredit-module--component--c62b5";
export var creditLabel = "MainImageCredit-module--creditLabel--26179";
export var fadePop = "MainImageCredit-module--fade-pop--10a08";
export var growHeightIn = "MainImageCredit-module--grow-height-in--96d51";